// Date/Time utilities
export const formatUTC = (date: Date): string => 
    date.toLocaleString(undefined, { timeZone: 'UTC', hour12: false });

export const parseGeneratedAt = (generatedAt?: string | null): Date | null => {
    if (!generatedAt) return null;
    try {
        const cleaned = generatedAt.replace(/\[.*\]$/, '');
        const parsedDate = new Date(cleaned);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
    } catch {
        return null;
    }
};

// Display transformation utilities
export const prettyDisplayTransform = (value: string): string => {
    const transformMap: Record<string, string> = {
        'AllClients': 'All Clients',
        'AllDiagnosticCodes': 'All Diagnostic Codes', 
        'AllProcessors': 'All Processors'
    };
    return transformMap[value] || value;
};

// Text utilities
export const truncateText = (text: string, maxLength: number = 28): string => 
    text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;

// Time window conversion utility
export const convertTimeWindowToDateRange = (
    timeWindow: string, 
    referenceDate?: Date
): { startDate: Date; endDate: Date } => {
    const reference = referenceDate || new Date();
    let startDate: Date;
    
    switch (timeWindow) {
        case 'now-24h':
            startDate = new Date(reference.getTime() - 24 * 60 * 60 * 1000);
            break;
        case 'now-30d':
            startDate = new Date(reference.getTime() - 30 * 24 * 60 * 60 * 1000);
            break;
        case 'now-60d':
            startDate = new Date(reference.getTime() - 60 * 24 * 60 * 60 * 1000);
            break;
        case 'now-90d':
            startDate = new Date(reference.getTime() - 90 * 24 * 60 * 60 * 1000);
            break;
        case 'now-1y':
        default:
            startDate = new Date(reference.getTime() - 365 * 24 * 60 * 60 * 1000);
            break;
    }
    
    return { startDate, endDate: reference };
};

// Constants
export const TIME_WINDOW_OPTIONS = [
    { value: 'now-1y', label: 'Last 1 Year' },
    { value: 'now-24h', label: 'Last 24 Hours' },
    { value: 'now-30d', label: 'Last 30 Days' },
    { value: 'now-60d', label: 'Last 60 Days' },
    { value: 'now-90d', label: 'Last 90 Days' },
] as const;
